module.exports = __webpack_public_path__ + "static/media/noActivityIcon.29bfec77.svg";